export default __webpack_public_path__ + "static/media/clock_calendar_item.180aa561.svg";